import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Puts every route change at the top of the screen it opened. AC-SCROLL-F1.
 *
 * A route change here swaps the rendered tree without a document load, so the browser keeps the
 * offset it had: leaving the home page from its footer used to land ~4000px down whatever came
 * next, and opening a business from the bottom of the list opened its profile part-way through
 * itself. Mounted once beside the routes rather than called from each screen, because every route
 * has the problem for the same reason and a per-screen call is one more thing to remember.
 *
 * Keyed on `pathname`, not the whole location: the admin list keeps its page and query in the
 * search string (AC-BIZSEARCH-E1), and keying on the full location would jump the page to the top
 * on every keystroke in the search box. AC-SCROLL-E1.
 *
 * A layout effect rather than an effect — it runs before the browser paints, so the new screen is
 * never shown at the old screen's offset first.
 */
/**
 * The same move, for the places that are not route changes — pressing Save at the foot of a
 * profile form, whose answers (a rejected field, the read-only view edit mode collapses back
 * into) are all at the head of it. AC-SCROLL-F2.
 */
export const scrollToTop = () => window.scrollTo(0, 0);

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    scrollToTop();
  }, [pathname]);

  return null;
};

export default ScrollToTop;
